export default {
  // Ad platform types (for i18n)
  'adsPlatform.80004001': 'Google',
  'adsPlatform.80004002': 'Facebook',
  'adsPlatform.80004003': 'Twitter',
  'adsPlatform.80004004': 'TikTok',
  'adsPlatform.80004005': 'Adjust',
  'adsPlatform.80004006': 'SGTM',
  // Attribution event types (for i18n)
  'adsEvent.80005001': 'Registro',
  'adsEvent.80005002': 'Primer depósito',
  'adsEvent.80005003': 'Depósito recurrente',
  // Upload status types (for i18n)
  'adsPushStatus.80006001': 'Subiendo',
  'adsPushStatus.80006002': 'Error de subida',
  'adsPushStatus.80006003': 'Subida correcta',
  // Page title
  'adsAccount.title': 'Lista de cuentas de atribución',

  // Search fields
  'adsAccount.platform': 'Plataforma de atribución',
  'adsAccount.name': 'Nombre de atribución',

  // Buttons
  'adsAccount.search': 'Buscar',
  'adsAccount.reset': 'Restablecer',
  'adsAccount.add': 'Añadir',
  'adsAccount.edit': 'Editar',
  'adsAccount.delete': 'Eliminar',
  'adsAccount.save': 'Guardar',
  'adsAccount.cancel': 'Cancelar',

  // Table columns
  'adsAccount.serial': 'Serie',
  'adsAccount.adsId': 'ID de cuenta de plataforma',
  'adsAccount.conversionId': 'ID de conversión',
  'adsAccount.gtmId': 'GTM-ID',
  'adsAccount.mccAccount': 'Cuenta MCC asociada',
  'adsAccount.accessToken': 'Token de acceso',
  'adsAccount.clientId': 'ID de cliente OAuth',
  'adsAccount.registerEventPath': 'ID de evento de registro',
  'adsAccount.firstRechargeEventPath': 'ID de evento de primer depósito',
  'adsAccount.rechargeEventPath': 'Ruta de evento de recarga',
  'adsAccount.registerConversionLabel': 'Etiqueta de conversión de registro (GTM)',
  'adsAccount.firstRechargeConversionLabel': 'Etiqueta de conversión de primer recargo (GTM)',
  'adsAccount.repeatRechargeConversionLabel': 'Etiqueta de conversión de recargo repetido (GTM)',
  'adsAccount.status': 'Estado',
  'adsAccount.otherParams': 'Parámetros de atribución',
  'adsAccount.action': 'Acción',

  // Status
  'adsAccount.active': 'Activo',
  'adsAccount.inactive': 'Inactivo',

  // Form validation
  'adsAccount.platformRequired': 'Por favor seleccione la plataforma de atribución',
  'adsAccount.nameRequired': 'Por favor ingrese el nombre de atribución',
  'adsAccount.adsIdRequired': 'Por favor ingrese el ID de cuenta de plataforma',
  'adsAccount.conversionIdRequired': 'Por favor ingrese el ID de conversión',
  'adsAccount.mccAccountRequired': 'Por favor seleccione la cuenta MCC asociada',
  'adsAccount.mccAccountPlaceholder': 'Por favor ingrese la cuenta MCC asociada',
  'adsAccount.accessTokenRequired': 'Por favor ingrese el token de acceso',
  'adsAccount.clientIdRequired': 'Por favor ingrese el ID de cliente OAuth',
  'adsAccount.registerEventPathRequired': 'Por favor ingrese el ID de evento de registro',
  'adsAccount.firstRechargeEventPathRequired': 'Por favor ingrese el ID de evento de primer depósito',
  'adsAccount.repeatRechargeEventPathRequired': 'Por favor ingrese la ruta de evento de recarga',

  // Form placeholders
  'adsAccount.namePlaceholder': 'Por favor ingrese el nombre de atribución',
  'adsAccount.adsIdPlaceholder': 'Por favor ingrese el ID de cuenta de plataforma',
  'adsAccount.conversionIdPlaceholder': 'Por favor ingrese el ID de conversión',
  'adsAccount.registerEventPathPlaceholder': 'ej.: /register/123',
  'adsAccount.firstRechargeEventPathPlaceholder': 'ej.: /recharge/123',
  'adsAccount.registerConversionLabelPlaceholder': 'ej.: 5txfCOaKzuwbEOPCia9A',
  'adsAccount.firstRechargeConversionLabelPlaceholder': 'ej.: 5txfCOaKzuwbEOPCia9A',
  'adsAccount.repeatRechargeConversionLabelPlaceholder': 'ej.: 5txfCOaKzuwbEOPCia9A',

  // Modal title
  'adsAccount.addAdsAccount': 'Añadir configuración de atribución de anuncios',
  'adsAccount.editAdsAccount': 'Editar configuración de atribución de anuncios',

  // Messages
  'adsAccount.addSuccess': 'Añadido exitosamente',
  'adsAccount.addFailed': 'Error al añadir',
  'adsAccount.editSuccess': 'Actualizado exitosamente',
  'adsAccount.editFailed': 'Error al actualizar',
  'adsAccount.deleteSuccess': 'Eliminado exitosamente',
  'adsAccount.deleteFailed': 'Error al eliminar',
  'adsAccount.confirmDelete': '¿Seguro que desea eliminar este registro?',
  'adsAccount.validationError': 'Por favor complete todos los campos requeridos',
  'adsAccount.fetchDataFailed': 'Error al obtener datos',
  'adsAccount.fetchTypesFailed': 'Error al obtener tipos de plataforma de atribución',
  'adsAccount.fetchMccAccountsFailed': 'Error al obtener cuentas MCC',
  'adsAccount.noData': 'Sin datos',

  // Pagination
  'adsAccount.totalRecords': 'Total {total} registros',
  'adsAccount.pagination': 'Página {current} de {page}, Total {total} registros',
};
